import React, { useState } from "react";
import { useFloating, useHover, useInteractions } from "@floating-ui/react";

import styles from "./HelpHoverIcon.module.scss";
import { ReactComponent as Help } from "assets/misc/question_mark.svg";

interface HelpHoverIconProps {
  message: string;
}

const HelpHoverIcon = ({ message }: HelpHoverIconProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { refs, floatingStyles, context } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement: "top-start",
  });
  const hover = useHover(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([hover]);
  const formattedMessage = message.split("\n").map((line, index) => (
    <div key={index} className={styles.messageLine}>
      {line}
    </div>
  ));

  return (
    <>
      <Help ref={refs.setReference} {...getReferenceProps()} />
      {isOpen && (
        <div
          ref={refs.setFloating}
          className={styles.popupContainer}
          style={floatingStyles}
          {...getFloatingProps()}
        >
          {formattedMessage}
        </div>
      )}
    </>
  );
};

export default HelpHoverIcon;
